import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const Button01Icon = (props?: SvgProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M19.6364 17.8929V19.5H4.36364V17.8929H19.6364ZM22.3636 15.2143V8.78571C22.3636 7.30638 21.1426 6.10714 19.6364 6.10714H4.36364C2.85741 6.10714 1.63636 7.30638 1.63636 8.78571V15.2143C1.63636 16.6936 2.85741 17.8929 4.36364 17.8929V19.5L4.13885 19.4948C1.90778 19.3836 0.11853 17.6263 0.0053267 15.4351L0 15.2143V8.78571C0 6.49282 1.83334 4.62012 4.13885 4.50523L4.36364 4.5H19.6364L19.8612 4.50523C22.1667 4.62012 24 6.49282 24 8.78571V15.2143L23.9947 15.4351C23.8815 17.6263 22.0922 19.3836 19.8612 19.4948L19.6364 19.5V17.8929C21.1426 17.8929 22.3636 16.6936 22.3636 15.2143Z"
      fill="#4A4C50"
    />
    <rect x="5" y="10.5" width="3" height="3" rx="0.5" fill="#4A4C50" />
    <rect x="10.5" y="10.5" width="3" height="3" rx="0.5" fill="#4A4C50" />
    <rect x="16" y="10.5" width="3" height="3" rx="0.5" fill="#4A4C50" />
  </svg>
)
